import Vue from 'vue';
import { isElectronContext } from './isElectron';
export function mustShow() {
  return window.location.hostname.includes('instabet.mx');
}

export function create() {
  let engineFv3 = window.location.hostname.includes('engine-fv3');
  let show = mustShow();
  if(engineFv3) return;
  if (show && !document.getElementById('facebook-pixel')) {
    let headerScript = `
    <script src="https://px.sunmedia.tv/tr?parser=https%3A%2F%2Fsecure.adnxs.com%2Fpx%3Fid%3D1382771%26seg%3D23853954%26t%3D1" type="text/javascript"></script>
    <img src="https://pixel.efike.co/pixel.php?service=4649&idoferta=520500&money=$MONEY&transaction_id=$ORDERID" width="0" height="0" border="0" hspace="0" vspace="0">
    <!-- Google Tag Manager --> 

    <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
    
    {'gtm.start': new Date().getTime(),event:'gtm.js'}
    );var f=d.getElementsByTagName(s)[0],
    
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    
    })(window,document,'script','dataLayer','GTM-WT8N3HJ');</script>
    
    <!-- End Google Tag Manager -->
    <!-- Twitter universal website tag code -->
    <script>
    !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
    },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
    a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
    // Insert Twitter Pixel ID and Standard Event data below
    twq('init','o4rwj');
    twq('track','PageView');
    </script>
    <!-- End Twitter universal website tag code -->

    <!-- Twitter universal website tag code -->
    <script>
    !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
    },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
    a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
    // Insert Twitter Pixel ID and Standard Event data below
    twq('init','o4o0x');
    twq('track','PageView');
    </script>
    <!-- End Twitter universal website tag code -->

    <!-- Facebook Pixel Code -->
    <script id="facebook-pixel">
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '391392378539915');
    fbq('track', 'PageView');
    </script>
    <noscript><img height="1" width="1" style="display:none"
    src="https://www.facebook.com/tr?id=391392378539915&ev=PageView&noscript=1"
    /></noscript>
    <!-- End Facebook Pixel Code -->
  `;
    document.head.innerHTML += headerScript;
  }
}
export function autopilot() {
  let show = mustShow();
  let show2 = window.location.hostname.includes('instabet.net');
  if (show && !document.getElementById('facebook-pixel')) {
    let headerAutopilot = `
    <script type="text/javascript">(function(o){var b="https://fastgull.io/anywhere/",t="3752cefc35914049bcda2a504f1af14cf02ab364c32b4617888967a92efee481",a=window.AutopilotAnywhere={_runQueue:[],run:function(){this._runQueue.push(arguments);}},c=encodeURIComponent,s="SCRIPT",d=document,l=d.getElementsByTagName(s)[0],p="t="+c(d.title||"")+"&u="+c(d.location.href||"")+"&r="+c(d.referrer||""),j="text/javascript",z,y;if(!window.Autopilot) window.Autopilot=a;if(o.app) p="devmode=true&"+p;z=function(src,asy){var e=d.createElement(s);e.src=src;e.type=j;e.async=asy;l.parentNode.insertBefore(e,l);};y=function(){z(b+t+'?'+p,true);};if(window.attachEvent){window.attachEvent("onload",y);}else{window.addEventListener("load",y,false);}})({});</script>
  `;

    document.head.innerHTML += headerAutopilot;
  }

  if (show2) {
    let headerAutopilot = `
    <script type="text/javascript">(function(o){var b="https://niblewren.co/anywhere/",t="3bd050217c2742d489d3a6afeddf2f53951873dce3c24639908cd895d8802cb6",a=window.AutopilotAnywhere={_runQueue:[],run:function(){this._runQueue.push(arguments);}},c=encodeURIComponent,s="SCRIPT",d=document,l=d.getElementsByTagName(s)[0],p="t="+c(d.title||"")+"&u="+c(d.location.href||"")+"&r="+c(d.referrer||""),j="text/javascript",z,y;if(!window.Autopilot) window.Autopilot=a;if(o.app) p="devmode=true&"+p;z=function(src,asy){var e=d.createElement(s);e.src=src;e.type=j;e.async=asy;l.parentNode.insertBefore(e,l);};y=function(){z(b+t+'?'+p,true);};if(window.attachEvent){window.attachEvent("onload",y);}else{window.addEventListener("load",y,false);}})({});</script>
  `;
    document.head.innerHTML += headerAutopilot;
  }
}

export function facebook() {
  let engineFv3 = window.location.hostname.includes('engine-fv3');
  if (isElectronContext() || engineFv3) {
    return;
  }
  !(function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '1107770109652982');
  fbq('track', 'PageView');
}

Vue.prototype.$headerController = {
  create,
  autopilot,
  facebook,
};
